import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React, { useState } from "react";
import PasswordStrengthBar from "react-password-strength-bar";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { userRegisterFetch } from "../../actions/authActions";
import { getDocs } from "../../actions/getDocs";
import { loadBioData } from "../../actions/loadBioData";
import { loadRoutes } from "../../actions/loadRoutes";
import "../Login.css";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		"& > * + *": {
			marginTop: theme.spacing(2),
		},
		display: "flex",
		alignItems: "center",
	},
	wrapper: {
		margin: theme.spacing(1),
		position: "relative",
	},
	buttonSuccess: {
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[700],
		},
	},
	fabProgress: {
		color: green[500],
		position: "absolute",
		top: -6,
		left: -6,
		zIndex: 1,
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
}));

function Register(props) {
	const classes = useStyles();
	const [loading, setLoading] = React.useState(false);
	const [success, setSuccess] = React.useState(false);
	const timer = React.useRef();

	const buttonClassname = clsx({
		[classes.buttonSuccess]: success,
	});
	const [state, setState] = useState({
		username: "",
		password: "",
		email: "",
		firstname: "",
		lastname: "",
		passwordScore: 0,
	});
	const handleChangeScore = (value) => {
		console.log("handleChangeScore value=", value);
		setState({ ...state, passwordScore: value });
	};
	React.useEffect(() => {
		return () => {
			clearTimeout(timer.current);
		};
	}, []);

	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.value });
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		if (!loading) {
			setSuccess(false);
			setLoading(true);
			timer.current = setTimeout(() => {
				setSuccess(true);
				setLoading(false);
			}, 5000);
		}
		if (state.password !== state.reconfirmpassword) {
			return;
		}
		if (state.passwordScore < 4) {
			return;
		}
		if (
			state.username !== "" &&
			state.email !== "" &&
			state.firstname !== "" &&
			state.lastname !== "" &&
			state.password !== ""
		)
			props.userRegisterFetch(state);

		console.log("handleSubmit state=", state);
	};

	return (
		<div className={classes.root}>
			<div className="login">
				<div className="login-triangle"></div>

				<h2 className="login-header">Register</h2>
				<form className="login-container" onSubmit={handleSubmit}>
					<p>
						<input
							required
							name="username"
							placeholder="Username"
							value={state.username}
							onChange={handleChange}
						/>
					</p>
					<p>
						<input
							required
							name="email"
							type="email"
							placeholder="Email"
							value={state.email}
							onChange={handleChange}
						/>
					</p>

					<p>
						<input
							required
							id="password"
							type="password"
							name="password"
							placeholder="Password"
							value={state.password}
							onChange={handleChange}
						/>

						<input
							required
							type="password"
							id="reconfirmpassword"
							name="reconfirmpassword"
							placeholder="Reconfirm Password"
							value={state.reconfirmpassword}
							onChange={handleChange}
						/>
					</p>
					<PasswordStrengthBar
						password={state.password}
						onChangeScore={handleChangeScore}
					/>
					<p>
						<input
							required
							name="lastname"
							placeholder="Lastname"
							value={state.lastname}
							onChange={handleChange}
						/>
					</p>
					<p>
						<input
							required
							name="firstname"
							placeholder="Firstname"
							value={state.firstname}
							onChange={handleChange}
						/>
					</p>

					<div className={classes.wrapper}>
						<input
							type="submit"
							className={buttonClassname}
							disabled={loading}
						/>

						{loading && (
							<CircularProgress size={24} className={classes.buttonProgress} />
						)}
						<Link to="/">Login</Link>
					</div>
				</form>
				{props.state.auth.errormessage ? props.state.auth.errormessage : ""}
				{props.state.auth.isLoading ? <LinearProgress variant="query" /> : ""}
			</div>
		</div>
	);
}

///const mapStateToProps = state => ({ authReducer: state.authReducer });
const mapStateToProps = (state) => ({ state });

const mapDispatchToProps = (dispatch) => ({
	userRegisterFetch: (userInfo) => dispatch(userRegisterFetch(userInfo)),
	loadRoutes: (data) => dispatch(loadRoutes(data)),
	getDocs: (data) => dispatch(getDocs(data)),
	loadBioData: (data) => dispatch(loadBioData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
